export default __webpack_public_path__ + "static/media/img-goals_3.70c7d1bc.svg";